import type { NextPage } from 'next'
import { useEffect, useRef } from 'react'

import { Box } from '../components/box'
import { Container } from '../components/layout/grid'
import type { PageFragment } from '../graphql/fragments/PageFragment.graphql'
import { fetchContentfulPage } from '../lib/static/fetchStaticPage'
import { PAGE_OPTIONS } from '../lib/utils/page'
import { PageTemplate } from '../page-templates/generic-page'
import { handleServerSideError } from '../server/helpers/error'

const CookieList: NextPage<Props> = ({ page }) => {
    const scriptContainer = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        if (scriptContainer.current) {
            const script = document.createElement('script')
            script.src =
                'https://consent.cookiebot.com/3ef82a53-815b-45ab-aefb-446000f27d26/cd.js'
            script.async = true

            scriptContainer.current.appendChild(script)
        }
    }, [])

    return (
        <PageTemplate {...PAGE_OPTIONS.COOKIE_LIST} pageData={page}>
            <Container>
                <Box ref={scriptContainer} />
            </Container>
        </PageTemplate>
    )
}

export default CookieList

export const getServerSideProps = handleServerSideError(async () => {
    const page = await fetchContentfulPage(PAGE_OPTIONS.COOKIE_LIST.slug)

    return { props: { page } }
})

interface Props {
    page: PageFragment
}
